import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import BottomNav from './BottomNav';
import NavBar from './NavBar';
import AssistantOverlay from './AssistantOverlay';


const AppNavigation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [assistantOpen, setAssistantOpen] = useState(false);
  const [assistantMounted, setAssistantMounted] = useState(false);
  const [initialConversationId, setInitialConversationId] = useState(null);
  const previousPath = useRef(location.pathname);
  const hideTopNavigation = location.pathname === '/' || location.pathname === '/sign-up';

  const openAssistant = useCallback(() => {
    setAssistantMounted(true);
    setAssistantOpen(true);
  }, []);

  useEffect(() => {
    if (location.state?.openAssistant) {
      setInitialConversationId(location.state.assistantConversationId || null);
      openAssistant();
      const { openAssistant: _open, assistantConversationId: _id, ...state } = location.state;
      navigate({ pathname: location.pathname, search: location.search, hash: location.hash }, {
        replace: true, state: Object.keys(state).length ? state : null,
      });
    } else if (previousPath.current !== location.pathname) {
      setAssistantOpen(false);
    }
    previousPath.current = location.pathname;
  }, [location, navigate, openAssistant]);

  return (
    <>
      {!hideTopNavigation && <NavBar onOpenAssistant={openAssistant} />}
      <BottomNav onOpenAssistant={openAssistant} />
      {assistantMounted && <AssistantOverlay key={initialConversationId || 'recent'} open={assistantOpen} onClose={() => setAssistantOpen(false)} initialConversationId={initialConversationId} />}
    </>
  );
};

export default AppNavigation;
